import "./MenuEventsList.scss"

import { useEffect,useState } from "react"

import { EventDto } from "@/entities/app/menu/menu.dto"
import ExpandedButton from "@/shared/components/intrinsic/ExpandedButton/ExpandedButton"
import Field from "@/shared/components/intrinsic/Field/Field"
import { inputValue } from "@/utils/common"

import MenuEventItem from "../MenuEventItem/MenuEventItem"


interface MenuEventsListProps {
  events: EventDto[]
  companyId: string
  onCreate?(): void
  onEdit?(index: number): void
  onDelete?(index: number): void
}

function MenuEventsList(props: MenuEventsListProps) {
  const [searchQuery, setSearchQuery] = useState("")
  const [expandedEventIndex, setExpandedEventIndex] = useState<number | null>(null)

  const filteredEvents = props.events.filter(event =>
    event.name.toLowerCase().includes(searchQuery.toLowerCase())
  )

  // Handle accordion toggle behavior
  const handleToggle = (index: number) => {
    setExpandedEventIndex(prev => prev === index ? null : index)
  }

  // Close expanded item when search results change
  useEffect(() => {
    setExpandedEventIndex(null)
  }, [searchQuery])

  const hasEvents = props.events.length > 0

  return (
    <div className="menu-events-list">
      <div className="menu-events-list__header">
        <Field
          placeholder="Search for Events..."
          value={searchQuery}
          onChange={inputValue(setSearchQuery)}
          iconLeft="search"
        />
        <ExpandedButton onClick={() => props.onCreate?.()} name="Create Event" />
      </div>

      {!hasEvents && (
        <div className="menu-events-list__empty">
          <p className="menu-events-list__empty-title">Currently, there are no Events set up.</p>
          <p className="menu-events-list__empty-message">
            Use the plus button to create one if you&apos;re allowed, or contact your admin for support.
          </p>
        </div>
      )}

      {hasEvents && (
        <div className="menu-events-list__items">
          {filteredEvents.map((event) => {
            // Find the original index in the unfiltered events array
            const originalIndex = props.events.findIndex(e => e === event)
            return (
              <MenuEventItem
                key={originalIndex}
                event={event}
                expanded={expandedEventIndex === originalIndex}
                companyId={props.companyId}
                onToggle={() => handleToggle(originalIndex)}
                onEdit={() => props.onEdit?.(originalIndex)}
                onDelete={() => props.onDelete?.(originalIndex)}
              />
            )
          })}
          {filteredEvents.length === 0 && searchQuery && (
            <p className="menu-events-list__no-results">No events found matching &quot;{searchQuery}&quot;</p>
          )}
        </div>
      )}
    </div>
  )
}

export default MenuEventsList
